import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// Must import before ./App: ES module imports execute in source order, and
// CRA's style-loader inserts each CSS file's <style> tag at evaluation time —
// so importing index.css after App meant every component's CSS (already
// evaluated while resolving App's import tree) loaded BEFORE these global
// base styles, letting rules like `.btn { display: inline-flex }` here win
// cascade ties against equal-specificity component overrides such as
// Navbar.css's `.navbar-cta { display: none }` on mobile.
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
